import { IconPaths } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, useModal } from 'app/components'
import { GrupoModal } from '../modal/GrupoModal'

export const GruposListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openModal = () =>
    showModal({
      title: t('modal.criar_grupo'),
      content: <GrupoModal />,
    })

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openModal}>
      {t('common.add')}
    </Button>
  )
}
